module.exports = __webpack_public_path__ + "img/prize_s@2x.4ecf6c68.png";